
import React, { useReducer, useEffect, memo, useCallback } from "react";
import { EncounterLoginComponent } from "../components/EncounterLoginComponent";
import {
  encounterReducer,
  initialState as encounterInitalState,
} from "../reducers/encounterReducer";
import { encounterActions } from "../actions/encounterActions";
import { Card, Container, Row, Col } from "react-bootstrap";
import "../components/component.css";
import { ListPatient } from "../components/ListPatient";
import { Header } from "../components/Header";
import { Loader } from "../components/Loader";
import { useInternationalization } from "../hooks/useInternationalization";
import { useEncountersTracker } from "../hooks/useEncountersTracker";
import { useIntl } from "react-intl";

export const MonitoraggioPaziente = memo(({ history }) => {
  const { trackEncounters, trackedEncounters } = useEncountersTracker();

  const { locale } = useInternationalization();
  const intl = useIntl();

  const [encounterState, dispatch] = useReducer(encounterReducer, encounterInitalState);

  const fetchEncounter = encounterID => {
    encounterActions.addEncounter(encounterID, locale, dispatch, intl);
  };

  const fetchStoredEncounters = useCallback(
    () => {
      if (trackedEncounters.length > 0) {
        const encountersIDs = trackedEncounters.map(
          encounter => encounter.id
        );
        encounterActions.retrieveEncounters(encountersIDs, locale, dispatch, intl);
      }
    },
    []
  );

  useEffect(() => {
    trackEncounters(encounterState.encounters || []);
  }, [encounterState.encounters]);

  useEffect(() => {
    fetchStoredEncounters();
  }, [fetchStoredEncounters]);

  return (
    <React.Fragment>
      <Header history={history} />
      {
        encounterState.loading ?
          <Loader overlay /> :
          null
      }
      {
        <Container>
          <Row className="align-items-center justify-content-center">
            <Col lg={8}>
              <Card className="border-0" style={{ marginTop: "2.5%" }}>
                <EncounterLoginComponent
                  login={id => fetchEncounter(id)}
                  locale={locale}
                />
                <ListPatient
                  encounters={encounterState.encounters}
                  onClickUpdate={encounterID => fetchEncounter(encounterID)}
                />
              </Card>
            </Col>
          </Row>
        </Container>
      }
    </React.Fragment>
  );
});
